var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_chevron_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.9862 8.00148C11.7197 8.00096 11.4613 8.09391 11.2561 8.2642L4.41094 13.9755C3.92578 14.3793 3.85938 15.1004 4.26263 15.5861C4.66588 16.0719 5.38608 16.1383 5.87124 15.7346L11.9862 10.6173L18.1012 15.5518C18.3369 15.7435 18.6392 15.8331 18.9411 15.801C19.243 15.7688 19.5197 15.6175 19.7099 15.3805C19.9211 15.1431 20.0239 14.8282 19.9936 14.5117C19.9633 14.1952 19.8026 13.9057 19.5501 13.7128L12.705 8.19567C12.4938 8.05229 12.2408 7.98392 11.9862 8.00148Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.8f8a625def2ca3a8b41cde5b4aa7fd56.svg";
export { ForwardRef as ReactComponent };